import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import autoScreenshareService from '/imports/ui/services/auto-screenshare';
import ScreenshareCancelModal from '/imports/ui/components/screenshare/cancel-modal/component';
import deviceInfo from '/imports/utils/deviceInfo';

const AutoScreenshareModal = ({ intl }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalCallbacks, setModalCallbacks] = useState({
    onRetry: null,
    onCancel: null,
    onSkip: null,
  });
  const [modalType, setModalType] = useState('cancel');
  const [isRecordingActive, setIsRecordingActive] = useState(false);

  // [Fix Issue 4] Event-driven modal state via service listener (replaces 100ms polling).
  // The listener receives an atomic snapshot of all modal state, eliminating
  // the race condition where separate getter calls could read inconsistent state.
  useEffect(() => {
    if ((deviceInfo.isIos && deviceInfo.isTablet) || deviceInfo.isMobile) {
      return;
    }

    const unsubscribe = autoScreenshareService.onModalChange((snapshot) => {
      setIsModalOpen(snapshot.isOpen);
      if (snapshot.isOpen) {
        setModalCallbacks(snapshot.callbacks);
        setModalType(snapshot.modalType);
        setIsRecordingActive(snapshot.recordingStatus);
      }
    });

    return unsubscribe;
  }, []);

  // [Fix N5] handleModalClose delegates to onCancel only — don't also call
  // hideCancelModal() here since onCancel callbacks already do it.
  // [Fix #12] Removed redundant setIsModalOpen(false) — onCancel triggers
  // hideCancelModal() which notifies listeners that already set isModalOpen = false.
  const handleModalClose = () => {
    if (modalCallbacks.onCancel) {
      modalCallbacks.onCancel();
    }
  };

  const handleRetry = () => {
    if (modalCallbacks.onRetry) {
      modalCallbacks.onRetry();
    }
  };

  const handleCancel = () => {
    if (modalCallbacks.onCancel) {
      modalCallbacks.onCancel();
    }
  };

  const handleSkip = () => {
    if (modalCallbacks.onSkip) {
      modalCallbacks.onSkip();
    }
    autoScreenshareService.hideCancelModal();
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen && (
        <ScreenshareCancelModal
          intl={intl}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          onRetry={handleRetry}
          onCancel={handleCancel}
          onSkip={handleSkip}
          priority="high"
          modalType={modalType}
          isRecordingActive={isRecordingActive}
        />
      )}
    </>
  );
};

export default injectIntl(AutoScreenshareModal);
